import type { AllRouteEndpoints } from "../routeTypes";

export const engagementLandingPagesAppGroupIdCustomSubdomain =
  "/engagement/landing_pages/:app_group_id/custom_subdomain";

export const engagementLandingPagesAppGroupIdCustomSubdomainCacheKeys: AllRouteEndpoints[] = [
  "/engagement/landing_pages/:app_group_id/custom_subdomain",
  "/engagement/landing_pages/:app_group_id/custom_domain_limits",
];

export const cloudflareHostnameDataStatuses = [
  "active",
  "pending",
  "active_redeploying",
  "moved",
  "pending_deletion",
  "deleted",
  "pending_blocked",
  "pending_migration",
  "pending_provisioned",
  "test_pending",
  "test_active",
  "test_active_apex",
  "test_blocked",
  "test_failed",
  "provisioned",
  "blocked",
] as const;

export const hostnameDataStatuses = ["pending", "active", "error", "expired"] as const;
